<template>
  <!-- 数据管理 - 企业组价数据库 author: zhangxiaofeng-->
  <div class="wrap data-management combination-main" ref="scrollBody" id="scrollBody">
    <div class="content--options" id="contentOptions">
      <operation-select-major
        @change="majorChangeFn"
        :refresh-region-list="refreshRegionList"
        :inventory-list="inventoryList"
        :quota-list="quotaList"
        @operateMoreMajor="calcTableHeight"
        :inventory-quota-list-changed="inventoryQuotaListChanged"
        parentRegion="combination"
      ></operation-select-major>
      <div class="list" :style="{'height': isFixed?'91px':''}">
        <div :class="{'fixed':isFixed, 'fold-menu': foldMenu}">
          <!-- 按钮组 -->
          <operation-buttons
            :button-list="buttonList"
            @clickHandle="topButtonClick"
            origin="database"
            @uploadHandle="uploadHandle"
            type="combination"
            :disabled-button="disabledButton"
            :tip-content="tipContent"
            class="float_left"
          ></operation-buttons>
          <!-- 高级搜索 -->
          <dialog-senior-search
            class="float_right"
            page="combination"
            @onSearch="seniorSearchHandle"
          ></dialog-senior-search>
          <!-- 搜索 -->
          <operation-search
            class="float_right"
            :showGroup="showGroup && pageType !== 'databaseBasis'"
            @onSearch="searchHandle"
            @groupTypeChange="groupTypeChange"
            :placeholder="placeholder"
          ></operation-search>
        </div>
      </div>
    </div>
    <!-- 移动到 弹窗 -->
    <dialog-move-to
      :show="dialog.moveTo.show"
      @submit="moveToSubmit"
      @cancel="moveToCancel"
      :edit-data="dialog.moveTo.data"
    ></dialog-move-to>
    <div class="tabcnt-simple">
      <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height: tableHeight + 'px'}" id="tree-table">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
            <div class="header-item is-leaf is-center" style="width: 40px;">
              <label>
                <!-- 表头那个全选 下拉框 -->
                <select-all
                  :reset-select-all="resetSelectAll"
                  :current-page-item-count="dataList.length"
                  :current-page-item-selected="selectItems.length"
                  :pageTotal="pageCount"
                  :top="31"
                  :left="-10"
                  @change="selectAllChange"
                ></select-all>
              </label>
            </div>
            <div class="header-item is-leaf is-left" style="width: 30px;"></div>
            <div class="header-item is-leaf is-left" style="width: 140px;">编码</div>
            <div class="header-item is-leaf is-left" style="width: 200px;">名称</div>
            <div class="header-item is-leaf is-left flex-1">项目特征</div>
            <div class="header-item is-leaf is-center" style="width: 80px;">单位</div>
            <div class="header-item is-leaf is-center" style="width: 66px;">含量</div>
            <div class="header-item is-leaf is-center" style="width: 120px;" v-if="pageType === 'databaseBasis'">上传人</div>
            <div class="header-item is-leaf is-center" style="width: 80px;">
              <span class="person-sort" @click="changeSort('time')">
                上传时间
                <i class="sort" :class="parameter.timeSort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')"></i>
              </span>
            </div>
            <div class="header-item is-leaf is-center" style="width: 80px;" v-if="pageType === 'databaseBasis'">数据来源</div>
            <div class="header-item is-leaf is-center" style="width: 80px;">被使用次数</div>
            <div class="header-item is-leaf is-center" style="width: 240px;" v-if="pageType !== 'databaseBasis'">标签</div>
            <template v-if="pageType === 'databaseBasis'">
              <div class="header-item is-leaf is-center" style="width: 80px;">审核人</div>
              <div class="header-item is-leaf is-left" style="width: 120px;">
                <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                  审核状态
                  <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
                </em>
              </div>
            </template>
            <div class="header-item is-leaf is-center" style="width: 80px;"></div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper">
            <template v-for="(item, index) in dataList">
              <!-- 清单行 -->
              <li class="flex flex-row row row--level-1">
                <div class="cell column_1 is-left" style="width: 40px;">
                  <w-checkbox @change="checkboxTap(item,index)" v-model="item.checked"></w-checkbox>
                </div>
                <div class="cell column_2 is-left" style="width: 30px;">
                  <a
                    class="view-more"
                    :class="{close:item.childShow}"
                    @click="itemUnfoldTap(index)"
                  ></a>
                </div>
                <div class="cell column_3 is-left" style="width: 140px;">{{item.addicode}}{{item.code}}</div>
                <div class="cell column_4 is-left" style="width: 200px;">{{item.description}}</div>
                <div class="cell column_5 is-left flex-1">{{item.spec}}</div>
                <div class="cell column_6 is-center" style="width: 80px;">{{item.unit}}</div>
                <div class="cell column_7 is-center" style="width: 66px;"></div>
                <template v-if="pageType === 'databaseBasis'">
                  <div class="cell column_8 is-center" style="width: 120px;"></div>
                </template>
                <div class="cell column_9 is-center" style="width: 80px;"></div>
                <div class="cell column_10 is-center" style="width: 80px;" v-if="pageType === 'databaseBasis'"></div>
                <div class="cell column_11 is-center" style="width: 80px;"></div>
                <div class="cell column_12 is-center" style="width: 240px;" v-if="pageType !== 'databaseBasis'"></div>
                <template v-if="pageType === 'databaseBasis'">
                  <div class="cell column_13 is-center" style="width: 80px;"></div>
                  <div class="cell column_14 is-center" style="width: 120px;"></div>
                </template>
                <div class="cell column_15 is-center" style="width: 80px;">
                  <el-tooltip content="修改">
                    <i class="w-icon-xiugai cursor-pointer margin-right-10" :class="[item.professionAllowed ? '' : 'invalid']" @click.stop="dealItem('edit', {item})"></i>
                  </el-tooltip>
                  <el-tooltip content="删除">
                    <i class="r2-icon-action_delete_outline cursor-pointer margin-right-10" :class="[item.professionAllowed ? '' : 'invalid']" @click.stop="dealItem('delete', {item})"></i>
                  </el-tooltip>
                  <el-tooltip content="移动到">
                    <i class="w-icon-yidong cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']" @click.stop="dealItem('move', {item})"></i>
                  </el-tooltip>
                </div>
              </li>
              <collapse>
                <li class="flex flex-row row row--level-2" :key="item.normItemDataId" v-show="item.childShow">
                  <div class="tree-table fit flex flex-column table-medium table-beyond-hiding">
                    <div class="body-wrapper flex-1" style="overflow: auto;">
                      <ul class="container" :style="{width: tableWidth + 'px'}">
                        <template v-for="(planItem, planIndex) in item.estiDetailList">
                          <!-- 方案行 -->
                          <li class="flex flex-row row row--level-3" :key="'child'+ planIndex">
                            <div class="cell column_1 is-left" style="width: 40px;">
                              <w-checkbox @change="childCheckboxTap(item, index, planIndex)" v-model="planItem.checked"></w-checkbox>
                            </div>
                            <div class="cell column_2 is-left" style="width: 10px;"></div>
                            <div class="cell column_3 is-left" style="width: 30px;">
                              <a class="view-more" :class="{close: planItem.childShow}" @click="itemUnfoldTap(index, planIndex)"></a>
                            </div>
                            <div class="cell column_4 is-left flex-1">
                              <b class="font-blue">方案{{planIndex+1}}</b>
                              <i class="w-icon-xianshizuijiazujia zan" v-if="planItem.bestEsti"></i>
                            </div>
                            <div class="cell column_5 is-center" style="width: 80px;"></div>
                            <div class="cell column_6 is-center" style="width: 66px;"></div>
                            <div class="cell column_7 is-center break-word-wrap" style="width: 120px;" v-if="pageType === 'databaseBasis'">
                              {{planItem.userName}}
                            </div>
                            <div class="cell column_8 is-center" style="width: 80px;">{{planItem.esticreatetime}}</div>
                            <div class="cell column_9 is-center" style="width: 80px;" v-if="pageType === 'databaseBasis'">{{planItem.source}}</div>
                            <div class="cell column_10 is-center" style="width: 80px;">{{planItem.useCount}}</div>
                            <div class="cell column_11 is-center" style="width: 240px;" v-if="pageType !== 'databaseBasis'">
                              <div class="groupTag width-full" @click="tagTap(planItem)">{{planItem.tagLabels}}</div>
                            </div>
                            <template v-if="pageType === 'databaseBasis'">
                              <div class="cell column_12 is-left" style="width: 80px;">
                                {{!planItem.inspector && +planItem.inspected > 0 ? '无需审核' : planItem.inspector}}
                              </div>
                              <div class="cell column_13 is-left" style="width: 120px;">
                                <div class="action-inspect" v-if="+planItem.inspected === 0">
                                  <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                                        @click="dealItem('inspect', {item, planItem}, index, true)">
                                    通过
                                  </span>
                                  <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                                            @click="dealItem('inspect', {item, planItem}, index, false)">
                                    不通过
                                  </span>
                                </div>
                                <span class="inspect-status accept" v-else-if="+planItem.inspected === 1">
                                  审核通过
                                </span>
                                <span class="inspect-status reject" v-else-if="+planItem.inspected === 2">
                                  审核未通过
                                </span>
                              </div>
                            </template>
                            <div class="cell column_14 is-right" style="width: 80px;">
                               <span v-if="pageType === 'databaseBasis'">
                                <template v-if="planItem.bestEsti">
                                  <el-tooltip content="取消最佳组价">
                                    <i :class="['w-icon-quxiaozuijiazujia', (!item.professionAllowed || (pageType === 'databaseBasis' && planItem.inspected === 2))  ? 'invalid' : '']"
                                       @click="dealItem('setBestCombination', {item, planItem}, index, false)"></i>
                                  </el-tooltip>
                                </template>
                                <template v-else>
                                  <el-tooltip content="设为最佳组价">
                                    <i :class="['w-icon-dianzan', (!item.professionAllowed || (pageType === 'databaseBasis' && planItem.inspected === 2)) ? 'invalid' : '']"
                                       title="设为最佳组价"
                                       @click="dealItem('setBestCombination', {item, planItem}, index, true)"></i>
                                  </el-tooltip>
                                </template>
                              </span>
                              <el-tooltip content="删除">
                                <i :class="['r2-icon-action_delete_outline', item.professionAllowed ? '' : 'invalid']"
                                   v-on:click.stop="dealItem('deletePlan', {item, planItem})"></i>
                              </el-tooltip>
                            </div>
                          </li>
                          <!-- 定额行 -->
                          <template v-if="planItem.childShow">
                            <template v-for="(quotaItem, quotaIndex) in planItem.normItem">
                              <li class="flex flex-row row row--level-4" :key="'datagrand' + quotaIndex">
                                <div class="cell column_1 is-left" style="width: 80px;">
                                  <w-checkbox @change="childCheckboxTap(item, index, planIndex)" v-model="planItem.checked"></w-checkbox>
                                </div>
                                <div class="cell column_2 is-left" style="width: 30px;">
                                  <a class="view-more" :class="{close: quotaItem.childShow}" @click="itemUnfoldTap(index, planIndex, quotaIndex)"></a>
                                </div>
                                <div class="cell column_3 is-center" style="width: 80px;">{{quotaItem.code}}</div>
                                <div class="cell column_4 is-left flex-1">{{quotaItem.description}}</div>
                                <div class="cell column_5 is-center" style="width: 80px;">{{quotaItem.unit}}</div>
                                <div class="cell column_6 is-center" style="width: 66px;">{{quotaItem.usage}}</div>
                                <div class="cell column_7 is-center break-word-wrap" style="width: 120px;" v-if="pageType === 'databaseBasis'"></div>
                                <div class="cell column_8 is-center" style="width: 80px;"></div>
                                <div class="cell column_9 is-center" style="width: 80px;" v-if="pageType === 'databaseBasis'"></div>
                                <div class="cell column_10 is-center" style="width: 80px;"></div>
                                <div class="cell column_11 is-center" style="width: 240px;" v-if="pageType !== 'databaseBasis'"></div>
                                <template v-if="pageType === 'databaseBasis'">
                                  <div class="cell column_12 is-left" style="width: 80px;"></div>
                                  <div class="cell column_13 is-left" style="width: 120px;"></div>
                                </template>
                                <div class="cell column_14 is-right" style="width: 80px;">
                                  <el-tooltip content="修改">
                                    <i class="w-icon-xiugai cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']"
                                       @click.stop="dealItem('editQuota', {item, planItem, quotaItem})">
                                    </i>
                                  </el-tooltip>
                                </div>
                              </li>
                              <collapse>
                                <li class="flex flex-row row row--level-5 padding-10-0 collapse" v-show="quotaItem.childShow" :key="'datagrandchil'+quotaIndex">
                                  <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" v-if="!regionQuotaKeyData">
                                    <div class="header-wrapper" style="background: #f1f7e3;">
                                      <div class="table-header flex flex-row"  :style="{width: tableWidth + 'px'}">
                                        <div class="header-item is-leaf is-center" style="width: 70px;"></div>
                                        <div class="header-item is-leaf is-left" style="width: 140px;">编码</div>
                                        <div class="header-item is-leaf is-left flex-1">名称</div>
                                        <div class="header-item is-leaf is-center" style="width: 100px;">规格型号</div>
                                        <div class="header-item is-leaf is-center" style="width: 40px;">单位</div>
                                        <div class="header-item is-leaf is-center" style="width: 50px;">含量</div>
                                        <div class="header-item is-leaf is-center" style="width: 100px;">含税市场价(元)</div>
                                        <div class="header-item is-leaf is-center" style="width: 130px;">不含税市场价(元)</div>
                                        <div class="header-item is-leaf is-center" style="width: 100px;">税率(%)</div>
                                        <div class="header-item is-leaf is-center" style="width: 100px;"></div>
                                      </div>
                                    </div>
                                    <div class="body-wrapper flex-1" style="overflow: auto;">
                                      <ul class="container" :style="{width: tableWidth + 'px'}">
                                        <template v-for="(materialItem, materialIndex) in quotaItem.resList">
                                          <li class="flex flex-row row row--level-6" :key="'res' + materialIndex">
                                            <div class="cell column_1 is-left" style="width: 70px;"></div>
                                            <div class="cell column_2 is-left" style="width: 140px;">{{materialItem.code}}</div>
                                            <div class="cell column_3 is-left flex-1">{{materialItem.description}}</div>
                                            <div class="cell column_4 is-center" style="width: 100px;">{{materialItem.spec}}</div>
                                            <div class="cell column_5 is-left" style="width: 40px;">{{materialItem.unit}}</div>
                                            <div class="cell column_6 is-left" style="width: 50px;">{{materialItem.usage}}</div>
                                            <div class="cell column_7 is-left" style="width: 100px;">{{materialItem.marketRate}}</div>
                                            <div class="cell column_8 is-left" style="width: 130px;">{{materialItem.marketPreTaxRate}}</div>
                                            <div class="cell column_9 is-left" style="width: 100px;">{{materialItem.taxRatio}}</div>
                                            <div class="cell column_10 is-right" style="width: 100px;">
                                              <el-tooltip content="修改">
                                                <i class="w-icon-xiugai cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']"
                                                   @click="dealItem('editMaterial', {item, planItem, quotaItem, materialItem})">
                                                </i>
                                              </el-tooltip>
                                            </div>
                                          </li>
                                        </template>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" v-else>
                                    <div class="header-wrapper">
                                      <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
                                        <div class="header-item is-leaf is-center" style="width: 70px;"></div>
                                        <div class="header-item is-leaf is-left" v-for="(resColumn, resColumnIndex) in regionQuotaKeyData"
                                             :key="'resHead' + resColumnIndex"
                                             :class="resColumn.className"
                                             :width="resColumn.width" :style="{width: resColumn.width + 'px'}">{{resColumn.name}}</div>
                                        <div class="header-item is-leaf is-center" style="width: 100px;"></div>
                                      </div>
                                    </div>
                                    <div class="body-wrapper flex-1" style="overflow: auto;">
                                      <ul class="container" :style="{width: tableWidth + 'px'}">
                                        <template v-for="(materialItem, materialIndex) in quotaItem.resList">
                                          <li class="flex flex-row row row--level-6" :key="'res'+ materialIndex">
                                            <div class="cell column_1 is-left" style="width: 70px;"></div>
                                            <div class="cell is-left"
                                                 v-for="(resColumn, resColumnIndex) in regionQuotaKeyData"
                                                 :key="'res' + resColumnIndex"
                                                 :class="[resColumn.className, 'column_' + (resColumnIndex + 2)]" :style="{width: resColumn.width + 'px'}">
                                              <span v-if="resColumn.or">{{materialItem[resColumn.key] || materialItem[resColumn.or]}}</span>
                                              <span v-else>{{materialItem[resColumn.key]}}</span>
                                            </div>
                                            <div class="cell is-right" :class="'column_' + (regionQuotaKeyData.length + 2)" style="width: 100px;">
                                              <el-tooltip content="修改">
                                                <!-- item, planItem, quotaItem, materialItem -->
                                                <i class="w-icon-xiugai cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']"
                                                   @click="dealItem('editMaterial', {item, planItem, quotaItem, materialItem})">
                                                </i>
                                              </el-tooltip>
                                            </div>
                                          </li>
                                        </template>
                                      </ul>
                                    </div>
                                  </div>
                                </li>
                              </collapse>
                            </template>
                          </template>
                        </template>
                      </ul>
                    </div>
                  </div>
                </li>
              </collapse>
            </template>
          </ul>
        </div>
      </div>
      <simple-table :isHeight="false" v-if="false"
                    :showNoData="dataList.length === 0"
                    :is-empty="dataList.length < 1"
                    :is-scroll="false">
        <!-- 表头 -->
        <template slot="headTable">
          <div class="table-head-wrapper" :class="{'th-fixed':isFixed, 'fold-menu': foldMenu}">
            <table cellspacing="0" cellpadding="0" border="0" class="table-head">
              <thead class="has-gutter">
              <tr>
                <th width="20" class="checkAllth">
                  <label class="checkbox-label th">
                    <!-- 表头那个全选 下拉框 -->
                    <select-all
                      :reset-select-all="resetSelectAll"
                      :current-page-item-count="dataList.length"
                      :current-page-item-selected="selectItems.length"
                      :pageTotal="pageCount"
                      :top="31"
                      :left="-6"
                      @change="selectAllChange"
                    ></select-all>
                  </label>
                </th>
                <th width="10"></th>
                <!-- 编码 -->
                <th width="140" class="font-left">编码</th>
                <!-- 名称 -->
                <th width="200" class="font-left table-name">名称</th>
                <!-- 项目特征 -->
                <th width="200" class="font-left">项目特征</th>
                <!-- 单位 -->
                <th width="80" class="font-center">单位</th>
                <!-- 含量 -->
                <th width="66" class="font-center">含量</th>
                <!-- 上传人 -->
                <th width="120" v-if="pageType === 'databaseBasis'">上传人</th>
                 <!-- 上传时间 -->
                <th width="80">
                    <span class="person-sort" @click="changeSort('time')">
                      上传时间
                      <i class="sort" :class="parameter.timesort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')">
                      </i>
                    </span>
                </th>
                <!-- 数据来源 新增 -->
                <th width="80" v-if="pageType === 'databaseBasis'">数据来源</th>
                <!-- 被使用次数 -->
                <th width="80" class="font-center">被使用次数</th>
                <!-- 标签 -->
                <th width="240" v-if="pageType !== 'databaseBasis'">标签</th>
                <!-- 审核人 -->
                <th width="80" v-if="pageType === 'databaseBasis'">审核人</th>
                <!-- 审核状态 组价 不需要按照审核状态排序 -->
                <th width="120" v-if="pageType === 'databaseBasis'" class="font-left">
                  审核状态
                  <!--
                  <template>
                    <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                      审核状态
                      <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
                    </em>
                  </template>
                  -->
                </th>
                <!-- 操作 -->
                <th width="80"></th>
              </tr>
              </thead>
            </table>
          </div>
        </template>

        <!-- 表主体 -->
        <template slot="body" v-if="dataList.length>0">
          <tbody id="projectContent">
            <template v-for="(item,index) in dataList">
              <!-- 清单行 -->
              <tr class="trItem highlight border-b__none" :key="index">
                <td width="20" class="checkbox-td font-left">
                  <label class="checkbox-label">
                    <w-checkbox @change="checkboxTap(item,index)" v-model="item.checked"></w-checkbox>
                    <!--<input type="checkbox" @click="checkboxTap(item,index)" v-model="item.checked" />-->
                  </label>
                </td>
                <td width="10">
                  <a
                    class="view-more"
                    :class="{close:item.childShow}"
                    @click="itemUnfoldTap(index)"
                  ></a>
                </td>
                <td width="140" class="font-left">{{item.addicode}}{{item.code}}</td>
                <td width="200" class="font-left table-name">{{item.description}}</td>
                <td width="200" class="font-left">{{item.spec}}</td>
                <td width="80" class="font-center">{{item.unit}}</td>
                <td width="66" class="font-center">&nbsp;</td>
                <td width="120" v-if="pageType === 'databaseBasis'">&nbsp;</td>
                <td width="80">&nbsp;</td>
                <td width="80" v-if="pageType === 'databaseBasis'">&nbsp;</td>
                <td width="80" class="font-center"></td>
                <td width="240" v-if="pageType !== 'databaseBasis'">&nbsp;</td>
                <td width="80" v-if="pageType === 'databaseBasis'">&nbsp;</td>
                <td width="120" v-if="pageType === 'databaseBasis'">&nbsp;</td>
                <td width="80" class="td-btnbox operation">
                  <el-tooltip content="修改">
                    <i :class="['w-icon-xiugai', item.professionAllowed ? '' : 'invalid']"
                       @click.stop="dealItem('edit', {item})">
                    </i>
                  </el-tooltip>
                  <el-tooltip content="删除">
                    <i :class="['r2-icon-action_delete_outline', item.professionAllowed ? '' : 'invalid']"
                       @click.stop="dealItem('delete', {item})">
                    </i>
                  </el-tooltip>
                  <el-tooltip content="移动到">
                    <i  :class="['w-icon-yidong', item.professionAllowed ? '' : 'invalid']"
                        @click.stop="dealItem('move', {item})">
                    </i>
                  </el-tooltip>
                </td>
              </tr>
              <tr class="more-hidden border-t__none"
                v-show="item.childShow"
                :key="item.normItemDataId">
                <td :colspan="pageType === 'databaseBasis' ? 14 : 11" class="colspan">
                  <table class="ui-table_more table-layout"
                    width="100%"
                    cellspacing="0"
                    cellpadding="0" >
                    <tbody>
                      <template v-for="(planItem, planIndex) in item.estiDetailList">
                        <!-- 方案行 -->
                        <tr class="strat_plan" :key="'child'+ planIndex">
                          <td width="20" class="font-left">
                            <div class="checkbox-d">
                              <w-checkbox @change="childCheckboxTap(item, index, planIndex)" v-model="planItem.checked"></w-checkbox>
                            </div>
                          </td>
                          <td width="10"></td>
                          <td width="10">
                            <a class="view-more"
                               :class="{close: planItem.childShow}"
                               @click="itemUnfoldTap(index, planIndex)"></a>
                          </td>
                          <td colspan="2" width="546">
                            <b class="font-blue">方案{{planIndex+1}}</b>
                            <i class="w-icon-xianshizuijiazujia zan" v-if="planItem.bestEsti"></i>
                          </td>
                          <td width="80" class="font-center"></td>
                          <td width="66" class="font-center"></td>
                          <td width="120" v-if="pageType === 'databaseBasis'" class="break-word-wrap">
                            {{planItem.userName}}
                          </td>
                          <td width="81" class="font-center">{{planItem.esticreatetime}}</td>
                          <td width="81" class="font-center" v-if="pageType === 'databaseBasis'">{{planItem.source}}</td>
                          <td width="81" class="font-center">{{planItem.useCount}}</td>
                          <!-- 员工资料库  显示标签列 -->
                          <td width="242" v-if="pageType !== 'databaseBasis'">
                            <div class="groupTag" @click="tagTap(planItem)">{{planItem.tagLabels}}</div>
                          </td>
                          <td width="81" class="font-left" v-if="pageType === 'databaseBasis'">
                            {{!planItem.inspector && +planItem.inspected > 0 ? '无需审核' : planItem.inspector}}
                          </td>
                          <!-- 电子档案室 显示 审核状态列 -->
                          <td width="120" class="font-left" v-if="pageType === 'databaseBasis'">
                            <div class="action-inspect" v-if="+planItem.inspected === 0">
                              <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                                    @click="dealItem('inspect', {item, planItem}, index, true)">
                                通过
                              </span>
                              <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                                    @click="dealItem('inspect', {item, planItem}, index, false)">
                                不通过
                              </span>
                            </div>
                            <span class="inspect-status accept" v-else-if="+planItem.inspected === 1">
                              审核通过
                            </span>
                            <span class="inspect-status reject" v-else-if="+planItem.inspected === 2">
                              审核未通过
                            </span>
                          </td>
                          <td width="80" class="font-right operation">
                              <span v-if="pageType === 'databaseBasis'">
                                <template v-if="planItem.bestEsti">
                                  <el-tooltip content="取消最佳组价">
                                    <i :class="['w-icon-quxiaozuijiazujia', (!item.professionAllowed || (pageType === 'databaseBasis' && planItem.inspected === 2))  ? 'invalid' : '']"
                                      @click="dealItem('setBestCombination', {item, planItem}, index, false)"></i>
                                  </el-tooltip>
                                </template>
                                <template v-else>
                                  <el-tooltip content="设为最佳组价">
                                    <i :class="['w-icon-dianzan', (!item.professionAllowed || (pageType === 'databaseBasis' && planItem.inspected === 2)) ? 'invalid' : '']"
                                      title="设为最佳组价"
                                      @click="dealItem('setBestCombination', {item, planItem}, index, true)"></i>
                                  </el-tooltip>
                                </template>
                              </span>
                              <el-tooltip content="删除">
                                <i :class="['r2-icon-action_delete_outline', item.professionAllowed ? '' : 'invalid']"
                                   v-on:click.stop="dealItem('deletePlan', {item, planItem})"></i>
                              </el-tooltip>
                          </td>
                        </tr>
                        <!-- 定额行 -->
                        <tr :key="'childchild'+ planIndex" v-if="planItem.childShow">
                          <td :colspan="pageType === 'databaseBasis' ? 14 : 11" class="colspan">
                            <table class="ui-table_more table-layout"
                              width="100%"
                              cellspacing="0"
                              cellpadding="0">
                              <tbody>
                              <template v-for="(quotaItem, quotaIndex) in planItem.normItem" >
                                <tr :key="'datagrand' + quotaIndex">
                                  <td colspan="2" width="80" class="font-left">
                                    <div class="checkbox-d">
                                      <!--<input-->
                                      <!--type="checkbox"-->
                                      <!--v-model="planItem.checked"-->
                                      <!--@click="childCheckboxTap(item,index,planIndex)"-->
                                      <!--/>-->
                                      <w-checkbox @change="childCheckboxTap(item, index, planIndex)" v-model="planItem.checked"></w-checkbox>
                                    </div>
                                  </td>
                                  <td width="10">
                                    <a class="view-more"
                                       :class="{close: quotaItem.childShow}"
                                       @click="itemUnfoldTap(index, planIndex, quotaIndex)"></a>
                                  </td>
                                  <td width="80" class="break-word-wrap">{{quotaItem.code}}</td>
                                  <td width="418"
                                      class="break-word-wrap table-name" >{{quotaItem.description}}
                                  </td>
                                  <td width="81" class="font-center">{{quotaItem.unit}}</td>
                                  <td width="68" class="font-center">{{quotaItem.usage}}</td>
                                  <td width="120" v-if="pageType === 'databaseBasis'" class="break-word-wrap"></td>
                                  <td width="81"></td>
                                  <td width="81" v-if="pageType === 'databaseBasis'"></td>
                                  <td width="81" class="font-center"></td>
                                  <!-- 员工资料库  显示标签列 -->
                                  <td width="241" v-if="pageType !== 'databaseBasis'"></td>
                                  <td width="81" v-if="pageType === 'databaseBasis'"></td>
                                  <!-- 电子档案室 显示 审核状态列 -->
                                  <td width="120" class="font-left" v-if="pageType === 'databaseBasis'"></td>
                                  <td width="80" class="font-right operation">
                                    <span class="operation">
                                        <el-tooltip content="修改">
                                          <i :class="['w-icon-xiugai', item.professionAllowed ? '' : 'invalid']"
                                             @click.stop="dealItem('editQuota', {item, planItem, quotaItem})">
                                          </i>
                                        </el-tooltip>
                                      </span>
                                  </td>
                                </tr>
                                <tr class="more-hidden"
                                  v-if="quotaItem.childShow"
                                  :key="'datagrandchil'+quotaIndex">
                                  <td :colspan="pageType === 'databaseBasis' ? 14 : 11" class="colspan">
                                    <table class="table-light table-layout ui-mt10"
                                      width="100%"
                                      cellspacing="0"
                                      cellpadding="0"
                                      v-if="!regionQuotaKeyData">
                                      <thead>
                                      <tr class="h-34">
                                        <th width="70"></th>
                                        <th width="80" class="font-left">编码</th>
                                        <th width="150" class="font-left break-word-wrap">名称</th>
                                        <th width="100" class="font-center">规格型号</th>
                                        <th width="40" class="font-center">单位</th>
                                        <th width="50" class="font-right">实际含量</th>
                                        <th width="100" class="font-right">含税市场价(元)</th>
                                        <th width="100" class="font-right">不含税市场价(元)</th>
                                        <th width="100" class="font-right">税率(%)</th>
                                        <th width="160"></th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                        <tr class="h-32"
                                          v-for="(materialItem, materialIndex) in quotaItem.resList"
                                          :key="'res' + materialIndex">
                                          <td width="70"></td>
                                          <td class="font-left">{{materialItem.code}}</td>
                                          <td class="font-left">{{materialItem.description}}</td>
                                          <td class="font-center break-word-wrap">{{materialItem.spec}}</td>
                                          <td class="font-center">{{materialItem.unit}}</td>
                                          <td class="font-right">{{materialItem.usage}}</td>
                                          <td class="font-right">{{materialItem.marketRate}}</td>
                                          <td class="font-right">{{materialItem.marketPreTaxRate}}</td>
                                          <td class="font-right">{{materialItem.taxRatio}}</td>
                                          <td class="font-center">
                                            <span class="operation">
                                              <el-tooltip content="修改">
                                                <i :class="['w-icon-xiugai', item.professionAllowed ? '' : 'invalid']"
                                                   @click="dealItem('editMaterial', {item, planItem, quotaItem, materialItem})">
                                                </i>
                                              </el-tooltip>
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="table-light table-layout ui-mt10"
                                      width="100%"
                                      cellspacing="0"
                                      cellpadding="0"
                                      v-else>
                                      <thead>
                                      <tr class="h-34">
                                        <th width="70"></th>
                                        <th
                                          v-for="(resColumn, resColumnIndex) in regionQuotaKeyData"
                                          :key="'resHead' + resColumnIndex"
                                          :class="resColumn.className"
                                          :width="resColumn.width">
                                          {{resColumn.name}}
                                        </th>
                                        <th width="100"></th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                        <tr class="h-32"
                                          v-for="(materialItem, materialIndex) in quotaItem.resList"
                                          :key="'res'+ materialIndex">
                                          <td width="70"></td>
                                          <td v-for="(resColumn, resColumnIndex) in regionQuotaKeyData"
                                            :key="'res' + resColumnIndex"
                                            :class="resColumn.className">
                                            <span v-if="resColumn.or">{{materialItem[resColumn.key] || materialItem[resColumn.or]}}</span>
                                            <span v-else>{{materialItem[resColumn.key]}}</span>
                                          </td>
                                          <td class="font-right">
                                            <span class="operation">
                                              <el-tooltip content="修改">
                                                <!-- item, planItem, quotaItem, materialItem -->
                                                <i :class="['w-icon-xiugai', item.professionAllowed ? '' : 'invalid']"
                                                   @click="dealItem('editMaterial', {item, planItem, quotaItem, materialItem})">
                                                </i>
                                              </el-tooltip>
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </template>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
        <!--<div slot="body" v-else class="empty-box cursor-pointer" @click = "openHelp" >-->
          <!--<img src="@/assets/images/default_empty.png"/>-->
          <!--<p>点击这里上传您的第一条组价数据</p>-->
        <!--</div>-->
        <template slot="no-data">
          <a href="/doc/guide_zj.html" target="_blank">点击这里</a>
          上传您的第一条组价数据
        </template>
      </simple-table>
    </div>
    <!-- 分页区域 -->
    <div class="page-box" v-if="totalCount > 0">
      <w-pagination
        @current-change="changePageCurrent"
        @size-change="changePageSize"
        :current-page.sync="parameter.pageNum"
        background
        layout="total, prev, pager, next, jumper, sizes"
        :page-size="parameter.pageSize"
        :page-sizes="[50, 100, 150, 200]"
        :total="totalCount"
      ></w-pagination>
    </div>
    <!-- 上传云文件 -->
    <UploadCloudFiles
      v-if="UploadCloudFilesShow"
      @affirm="UploadCloudFilesAffirm"
      @cancle="UploadCloudFilesCancle"
    />
    <!-- 修改定额 弹窗 -->
    <dialog-edit-quota
      :show="editQuota.show"
      :editData="editQuota.editData"
      @cancel="editQuotaCancel"
      @submit="editQuotaSubmit">
    </dialog-edit-quota>
    <!-- 修改人材机 弹窗 -->
    <dialog-edit-material
      :show="editMaterial.show"
      :edit-data="editMaterial.editData"
      @submit="editMaterialSubmit"
      @cancel="editMaterialCancel"
    ></dialog-edit-material>
    <!-- 修改清单 弹窗 -->
    <dialog-edit-inventory
      :show="editInventory.show"
      :edit-data="editInventory.editData"
      @submit="editInventorySubmit"
      @cancel="editInventoryCancel"
    ></dialog-edit-inventory>
    <!-- 标签 弹窗 -->
    <dialog-edit-label
      :save-error-index="saveErrorIndex"
      :save-error="saveError"
      :show="labelData.show"
      @submit="labelDataSubmit"
      @cancel="labelData.show = false"
      :edit-data="labelData.data"
    ></dialog-edit-label>
    <!-- 结果 -->
    <w-dialog @close="upload.show=!upload.show" :show="upload.show">
      <span class="w__dialog--title" slot="header">{{upload.title}}</span>
      <p>{{upload.text}}</p>
      <div v-if="upload.detailShow && upload.detail.length">
        <br/>
        <p>未导入原因：</p>
        <p id="upload_result1">1、企业空间已存在相同数据</p>
      </div>
      <div slot="footer">
        <!--<input-->
        <!--class="ui-btn ui-btn_blue"-->
        <!--type="button"-->
        <!--value="查看详情"-->
        <!--v-if="upload.detail.length"-->
        <!--@click="showDetail"-->
        <!--/>-->
        <w-button type="primary" @click.stop.prevent="showDetail" v-if="upload.detail.length">查看详情
        </w-button>
        <template v-if="upload.title === '复制结果'">
          <!--<input class="ui-btn" type="button" value="关闭" @click="upload.show=!upload.show" />-->
          <w-button type="minor" @click.stop.prevent="upload.show=!upload.show">关闭</w-button>
        </template>
        <template v-else>
          <w-button type="minor" @click.stop.prevent="upload.show=!upload.show">继续导入</w-button>
          <w-button type="minor" @click.stop.prevent="upload.show=!upload.show">结束导入</w-button>
          <!--<input class="ui-btn" type="button" value="继续导入" @click="upload.show=!upload.show" />-->
          <!--<input class="ui-btn" type="button" value="结束导入" @click="upload.show=!upload.show" />-->
        </template>
      </div>
    </w-dialog>
    <!-- 返回顶部 -->
    <w-backtotop
      scroll-el="scrollBody"
      transition-name="bottomToTop"
      hover-text="返回顶部"
      hover-class="hover-class"
      :back-position="0"
      :visibility-height="110"
      icon-name="w-icon-xiala-copy icon-demo"
      custom-class="demo-3-class"
    ></w-backtotop>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {
  OperationSelectMajor,
  DialogSeniorSearch,
  OperationButtons,
  OperationSearch,
  SelectAll,
  Collapse,
  DialogEditMaterial,
  DialogEditInventory,
  DialogEditLabel,
  DialogEditQuota,
  DialogMoveTo,
  SimpleTable
} from '@/components/common'
import Bus from '@/assets/utils/bus'
import {getCookie} from '@/assets/utils/CommonUtil'
import CombinationService from '@/assets/service/combination'
import service from '@/assets/service'
import UploadCloudFiles from '_c/common/UploadCloudFiles/Index.vue'
import {backendUrl} from '@/assets/js/config'
import getRegionKey from './CombinationData'
import getQuotaRegionKey from './QuotaData'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
import uploadMixin from '@/assets/mixins/upload'
import databaseBasisMixin from '@/assets/mixins/database-basis'
import {isIE} from '@/assets/utils'

let uncheckedbqitemids = []
let unbqbaseinfoids = []
let unselectedSpecIds = []
export default {
  name: 'DatabaseCombination',
  components: {
    DialogEditInventory,
    DialogEditLabel,
    DialogSeniorSearch,
    OperationButtons,
    OperationSearch,
    OperationSelectMajor,
    SelectAll,
    Collapse,
    DialogEditMaterial,
    DialogEditQuota,
    DialogMoveTo,
    SimpleTable,
    UploadCloudFiles
  },
  mixins: [uploadMixin, databaseBasisMixin],
  data () {
    return {
      tableWidth: 0,
      scrollY: false,
      combinationUnfoldLevel: 'NORM', // 默认展开到的层级
      saveErrorIndex: 0,
      saveError: '', // 修改标签 保存时错误提示语
      resetSelectAll: 0,
      showGroup: true,
      buttonList: ['upload', 'export', 'copyToCompanySpace', 'move', 'inspectBatch', 'unfoldTo'],
      selectAll: '', // 全选下拉框 已选中的值 current: 当前页、all: 所有页
      refreshRegionList: 0, // 上传本地文件 平台接口 云文件之后 刷新地区列表
      inventoryQuotaListChanged: 0, // 清单列表、定额列表 改变时
      dialog: {
        // 弹窗
        moveTo: {
          show: false,
          data: {}
        },
        quota: {
          // 定额
          show: false, // 弹窗显示
          data: {} // 修改行的数据
        },
        material: {
          // 人材机
          show: false,
          data: {}
        },
        inventory: {
          // 清单
          show: false,
          data: {}
        }
      },
      totalCount: 0,
      pageCount: 0,
      dataList: [],
      isCheckAll: false,
      sortType: 1,
      parameter: {
        authorId: null, // 上传人ID
        code: null, // code
        dbidsStr: null, // 清单库id,多个用逗号分隔
        descOrSpec: null, // 名称或项目特征
        inspected: null, // 是否审查，true：审查，false：不审查
        labelKeyWord: null, // 关键字
        pageNum: 1, // 页码，从 1 开始
        pageSize: 50, // 每页多少条
        professionStr: null, // 专业章节ID,多个用逗号分隔
        regionStr: null, // 地区,多个用逗号分隔
        seriesStr: null, // 系列,多个用逗号分隔
        timeSort: null, // 时间排序顺序：1:降序，0:升序
        inspectedSort: null // 审核状态排序顺序：1:降序，0:升序
      },
      inventoryList: [], // 清单库 数据
      quotaList: [], // 定额库 数据
      UploadCloudFilesShow: false, // 上传云文件弹层控制
      currentPageItemCount: 20,
      currentPageItemSelected: 0,
      editQuota: {
        show: false,
        editData: {
          description: ''
        }
      },
      editInventory: {
        show: false,
        editData: {
          description: ''
        }
      },
      editMaterial: {
        show: false,
        editData: {
          description: ''
        }
      },
      labelData: {
        show: false,
        data: {}
      },
      regionKeyData: '',
      regionQuotaKeyData: '',
      isFixed: false,
      upload: {
        // 更新&复制
        show: false,
        text: '',
        title: '',
        detail: [],
        detailShow: false
      },
      user: {},
      placeholder: '请输入名称或项目特征',
      groupType: 1
    }
  },
  watch: {
    foldMenu (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.calcTableHeight()
        }, 500)
      }
    },
    totalCount (val) {
      this.pageCount = Math.ceil(val / this.parameter.pageSize)
    }
  },
  computed: {
    ...mapState({
      foldMenu: state => state.menus.foldMenu // 是否折叠菜单
    }),
    selectItems () {
      let selectItems = []
      this.dataList.map(item => {
        if (item.checked) {
          selectItems.push(item)
        }
      })
      return selectItems
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    if (this.pageType === 'databaseBasis') {
      // 企业组价数据 页面 批量操作增加 设置最佳组价 和 取消最佳组价
      this.buttonList = this.buttonList.concat(['signGroupBest', 'cancelGroupBest'])
    }
    this.buttonList.push('delete')
    // on(this.$refs.scrollBody, 'scroll', this.handleScroll)

    Bus.$on('uploadOne', file => {
      this.topButtonClick('refresh')
    })
    // Bus.$on('uploadAll', (file) => {
    //   // sessionStorage.setItem('combination_' + this.user.gldUserId, '');
    //   this.topButtonClick('refresh');
    // })
    Bus.$on('closeUploadCloudFile', () => {
      this.UploadCloudFilesShow = false
    })
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    this.calcTableHeight()
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.calcTableHeight()
    })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  beforeDestroy () {
    Bus.$off('uploadAll')
    // off(this.$refs.scrollBody, 'scroll', this.handleScroll)
    off(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
  },
  methods: {
    calcTableHeight () {
      let tableWidth = 636
      if (this.pageType === 'databaseBasis') {
        tableWidth += 640
      } else {
        tableWidth += 240
      }
      if (tableWidth < this.getDomWidth('scrollBody') - 20) {
        tableWidth = this.getDomWidth('scrollBody') - 20
      }
      if (this.scrollY) {
        tableWidth -= 17
      }
      this.tableWidth = tableWidth
      this.tableHeight = this.getTableHeight('scrollBody') - this.getTableHeight('contentOptions') - 30
    },
    // 滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    groupTypeChange (groupType) {
      this.groupType = groupType
      if (+groupType === 1) {
        this.placeholder = '请输入名称或项目特征'
      } else {
        this.placeholder = '请输入标签'
      }
    },
    // handleScroll() {
    //   if (document.getElementsByClassName('list')[0].getBoundingClientRect().top < 56) {
    //     this.isFixed = true
    //   } else {
    //     this.isFixed = false
    //   }
    // },
    // 1. 修改专业、切换地区、选择清单时 触发
    majorChangeFn (obj) {
      this.calcTableHeight()
      // console.log('majorChangeFn', obj)
      // 选定的地区记录到浏览器里
      sessionStorage.setItem('combination_' + this.user.gldUserId, obj.region)
      this.parameter.regionStr = obj.region
      if (obj.major) {
        this.parameter.professionStr = obj.major
      } else {
        this.parameter.professionStr = null
      }
      if (obj.dbidsStr) {
        this.parameter.dbidsStr = obj.dbidsStr
      } else {
        this.parameter.dbidsStr = null
      }
      if (obj.seriesStr) {
        this.parameter.seriesStr = obj.seriesStr
      } else {
        this.parameter.seriesStr = null
      }
      this.regionKeyData = getRegionKey(obj.region)
      if (obj.region === '湖北' && obj.seriesStr === '18序列') {
        this.regionQuotaKeyData = getQuotaRegionKey(obj.region + obj.seriesStr)
      } else {
        this.regionQuotaKeyData = getQuotaRegionKey(obj.region)
      }

      if (obj.changeType !== 'inventory' && obj.changeType !== 'quota') {
        this.getDbidsData()
      }
      if (obj.changeType !== 'region') {
        this.parameter.pageNum = 1
        this.getList()
      }
    },
    // 2. 搜索
    searchHandle (name) {
      console.log('00000000000000')
      if (+this.groupType === 1) {
        this.parameter.descOrSpec = name
        this.parameter.labelKeyWord = ''
      } else {
        this.parameter.descOrSpec = ''
        this.parameter.labelKeyWord = name
      }
      this.parameter.pageNum = 1
      this.getList()
    },
    // 2.1 高级搜索
    seniorSearchHandle (obj) {
      this.parameter.authorId = obj.authorId
      this.parameter.code = obj.code
      this.parameter.descOrSpec = obj.descOrSpec
      this.parameter.inspected = obj.inspected
      this.parameter.pageNum = 1
      this.getList()
    },
    // 3.1 上传
    uploadHandle (files, e, type) {
      switch (type) {
        case 'CloudFile': // 上传云文件
          this.UploadCloudFilesShow = true
          break
        case 'LocalFile': // 上传本地文件
          Bus.$emit('openUploader', {
            parameter: {
              uploadType: 5,
              params: JSON.stringify({
                IsOffline: false,
                SourceType: 4,
                ImportType: 2,
                userType: this.user.userType
              }),
              spaceType: this.pageType === 'databaseBasis' ? 2 : 1
            },
            uploadAction: 'data_manage/bill_quantity/upload_local_file'
          })
          break
        case 'PlatformFile': // 上传平台接口
          Bus.$emit('openUploader', {
            parameter: {
              uploadType: 6,
              params: JSON.stringify({
                IsOffline: false,
                SourceType: 3,
                ImportType: 2,
                userType: this.user.userType
              }),
              spaceType: this.pageType === 'databaseBasis' ? 2 : 1
            },
            uploadAction: 'data_manage/esti/upload_platform_file'
          })
          break
        default:
          // 普通的上传
          console.log('上传')
          console.log(files)
          console.log(e)
      }
    },
    // 3.2 顶部其他按钮点击
    topButtonClick (type, e, value) {
      switch (type) {
        case 'unfoldTo': // 展开到 value: BQ(清单)、NORM(定额)、RES(人材机)
          this.unfoldTo(value)
          break
        case 'signGroupBest': // 设置最佳组价
          this.dealItem('setBestCombination', {}, 0, true)
          break
        case 'cancelGroupBest': // 取消最佳组价
          this.dealItem('setBestCombination', {}, 0, false)
          break
        case 'copyToCompanySpace': //  复制到 电子档案室
        case 'export': // 导出
        case 'move': // 移动到
        case 'inspectBatch': // 批量 审核通过
        case 'delete':
          this.dealItem(type)
          break
        case 'refresh':
          this.selectAllChange('', false)
          this.parameter.pageNum = 1
          this.getDbidsData()
          this.getList(type)
          break
        default:
      }
    },
    // 3.2.1 展开到 value: BQ(清单)、NORM(定额)、RES(人材机)
    unfoldTo (value) {
      this.combinationUnfoldLevel = value
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      dataList.forEach(item => {
        if (value === 'BQ') {
          item.childShow = false
        } else {
          item.childShow = true
        }
        item.estiDetailList.forEach(citem => {
          if (value !== 'BQ') {
            citem.childShow = true
          } else {
            citem.childShow = false
          }
          citem.normItem.forEach(normItem => {
            if (value !== 'RES') {
              normItem.childShow = false
            } else {
              normItem.childShow = true
            }
          })
        })
      })
      this.dataList = dataList
    },
    // 3.2.1.1 清单、方案、定额 每一行数据 前面的 展开按钮 点击
    itemUnfoldTap (index, planIndex, quotaIndex) {
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      if (quotaIndex !== undefined) {
        // 展开人材机行
        dataList[index].estiDetailList[planIndex].normItem[quotaIndex].childShow = !dataList[index].estiDetailList[planIndex].normItem[quotaIndex].childShow
      } else if (planIndex !== undefined) {
        // 展开方案行
        dataList[index].estiDetailList[planIndex].childShow = !dataList[index].estiDetailList[planIndex].childShow
      } else if (index !== undefined) {
        // 展开清单行
        dataList[index].childShow = !dataList[index].childShow
      }
      this.dataList = dataList
    },
    // 4. 所有数据相关操作 统一入口
    dealItem (type, tableData = {}, idx, value) {
      // item: 清单行数据, planItem: 方案行数据, quotaItem: 定额行数据, materialItem: 人材机行数据
      const {item, planItem, quotaItem, materialItem} = tableData
      const bqspecid = [] // 选择的 清单ID 数组 一级
      const bqitemid = [] // 选择的 方案ID 数组 二级 （备注: 三级是 定额; 四级是 人材机）
      const selectItems = []
      let errorText = ''
      const dealChecked = (tempItem) => {
        if (tempItem.checked) {
          selectItems.push(tempItem)
          if (type === 'move') {
            // 移动 使用的是 清单的基础信息id ！！！！！
            bqspecid.push(tempItem.bqbaseinfoid)
          } else {
            // 其他情况使用的是 清单的 特征id ！！！！！
            bqspecid.push(tempItem.bqspecid)
          }
        }
        let checkedPlanLen = 0
        tempItem.estiDetailList.map(planItem => {
          if (type === 'move') {
            // 移动的是清单 就不需要关注 方案行数据了
          } else {
            if (planItem.checked) {
              checkedPlanLen++
              bqitemid.push(planItem.bqestidatadetailid)
              if (type === 'setBestCombination' && value && checkedPlanLen > 1) {
                // 批量设置最佳组价时 判断是否某个清单先同时选择了多个方案
                errorText = '一条清单下只允许设置一个最佳组价方案'
              }
            }
          }
        })
      }
      let professionStr = this.parameter.professionStr
      let parameter = {
        modelType: '_estiItem',
        bqspecidLen: 0,
        bqitemidLen: 0,
        bqspecid: '', // 清单ID
        bqitemid: '', // 方案ID
        professionStr, // 当前专业 当前专业 清单、定额都是使用的 profession 字段 ！！！！
        regionStr: this.parameter.regionStr, // 当前地区
        seriesStr: this.parameter.seriesStr, // 当前序列
        dbidsStr: this.parameter.dbidsStr, // 清单库id
        descOrSpec: this.parameter.descOrSpec, // 名称或项目特征
        code: this.parameter.code, // 编码
        authorId: this.parameter.authorId, // 上传人
        inspected: this.parameter.inspected, // 审核状态
        selectAllPages: false, // 是否
        uncheckedbqitemids: '', // 未选择的 方案ID
        unselectedSpecIds: '' // 未选择的 清单ID
      }
      if (item) {
        // 单数据操作
        const actions = [
          'editMaterial', 'editQuota', 'deletePlan', 'setBestCombination',
          'inspect', 'edit', 'delete', 'move'
        ]
        if (actions.includes(type) && !item.professionAllowed) {
          // 单条操作 时 无权限 则直接返回
          return
        }
        // dealChecked(item)
        switch (type) {
          case 'move': // 移动单条清单
            parameter.bqspecid = item.bqbaseinfoid
            break
          case 'deletePlan': // 删除方案
            parameter.bqitemid = planItem.bqestidatadetailid // 方案ID
            parameter.bqitemidLen = 1
            if (item.estiDetailList.length === 1) {
              // 如果某个清单只有一个 方案 那么 清单ID 字段也赋值
              parameter.bqspecid = item.bqspecid
            }
            break
          case 'delete':
            parameter.bqspecid = item.bqspecid
            break
          default:
        }
        professionStr = item.professionGuid
        parameter.bqspecidLen = 1
        parameter.bqitemidLen = 1
        parameter.selectAllPages = false
        this.operationBatch = false
      } else {
        // 批量操作
        if (type === 'export' && this.pageType === 'databaseBasis' && this.role !== 2) {
          // 总负责人 才能导出 电子档案室的数据
          return
        }
        this.dataList.map(tempItem => {
          dealChecked(tempItem)
        })
        if (this.selectAll === 'all') {
          // 全选所有页
          parameter.selectAllPages = true
          parameter.uncheckedbqitemids = uncheckedbqitemids.join(',')
          if (type === 'move') {
            parameter.unselectedSpecIds = unbqbaseinfoids.join(',')
          } else {
            parameter.unselectedSpecIds = unselectedSpecIds.join(',')
          }
          parameter.bqspecidLen = this.totalCount - unselectedSpecIds.length // 总共删除的 清单条数
        } else {
          parameter.selectAllPages = false
          parameter.bqspecid = bqspecid.join(',')
          parameter.bqitemid = bqitemid.join(',')
          parameter.bqspecidLen = bqspecid.length
          parameter.bqitemidLen = bqitemid.length
        }
        this.operationBatch = true
      }
      parameter.professionStr = professionStr
      console.log(parameter)
      switch (type) {
        // 批量导出
        case 'export':
          if (parameter.bqspecidLen === 0) {
            this.$message.info('请勾选要导出的组价数据')
            return
          }
          this.$confirm({
            message: '确定导出勾选的组价数据？',
            dealData: parameter,
            submit: data => {
              this.exportData(data)
            },
            submitText: '确定'
          })
          break
        // 复制到电子档案室
        case 'copyToCompanySpace':
          if (parameter.bqspecidLen === 0 && !parameter.selectAllPages) {
            this.$message.info('该功能仅支持清单数据，请勾选要复制的清单')
            return
          }
          this.$confirm({
            message: '确定要将勾选的组价数据复制到电子档案室？',
            width: 400,
            dealData: parameter,
            submit: (data) => {
              this.copyMaterialList(data)
            },
            submitText: '确定复制'
          })
          break
        // 修改清单
        case 'edit':
          this.editInventory = {
            show: true,
            editData: {
              professionStr,
              bqBaseInfoId: item.bqbaseinfoid, // 清单基础信息id
              bqSpecId: item.bqspecid, // 清单特征id
              description: item.description,
              spec: item.spec,
              unit: item.unit
            }
          }
          break
        // 批量删除清单、方案; 单条清单删除
        case 'delete':
          if (this.operationBatch) {
            if (parameter.bqitemidLen === 0 && parameter.bqspecidLen === 0) {
              this.$message.info('请选择需要删除的组价列表')
              return
            }
            let message = '确定删除勾选的组价数据？'
            if (this.selectAll === 'all') {
              message = `确定删除所有页（共${this.pageCount}页）数据？`
            }
            this.$confirm({
              message,
              type: 'warning',
              tips: '删除后，数据将不可恢复',
              width: 370,
              dealData: parameter,
              submit: data => {
                this.deleteConfirm(data)
              },
              submitText: '确定删除'
            })
          } else {
            // 删除单条清单
            this.$confirm({
              message: '确定删除？',
              type: 'warning',
              tips: '删除后，数据将不可恢复',
              dealData: parameter,
              submit: data => {
                this.deleteConfirm(data)
              },
              submitText: '确定删除'
            })
          }
          break
        // 移动清单
        case 'move':
          let catalogIdGuid = ''
          if (item) {
            catalogIdGuid = item.bqcatalogIdGuid
          } else {
            if (!parameter.bqspecidLen) {
              this.$message.info('该功能仅支持清单数据，请勾选要移动的清单')
              return
            } else {
              if (selectItems.length) {
                catalogIdGuid = selectItems[0].bqcatalogIdGuid
              } else {
                catalogIdGuid = this.dataList[0].bqcatalogIdGuid
              }
            }
          }
          service.inventory.getInventoryChapter({catalogIdGuid}).then((data) => {
            // console.log(data)
            if (+data.code === 200 && data.data) {
              // 请设置 移动到弹窗下拉框默认选中项 若不设置 默认选中select第一项
              this.dialog.moveTo.data = Object.assign({}, parameter, {
                bqitemid: parameter.bqspecid,
                bqspecid: '',
                uncheckedbqitemids: parameter.unselectedSpecIds,
                unselectedSpecIds: '',
                professionSelect: data.data.profession, // 当前所属的专业
                chapterSelect: data.data.chapter // 当前所属的章节
              })
              this.dialog.moveTo.show = true
            }
          })
          break
        // 批量 审核通过
        case 'inspectBatch':
          if (bqitemid.length === 0) {
            this.$message.info('请勾选要审核的组价数据')
          } else {
            this.loading = true
            CombinationService.inspectBatch({inspection: true}, parameter).then(res => {
              if (+res.code === 200) {
              } else {
                // +data.code === 290004 无权限操作数据时 操作失败
                // this.$message.error('操作失败')
              }
              this.topButtonClick('refresh')
            }).catch((e) => {
              console.log(e)
              this.loading = false
            })
          }
          break
        // 单数据审核
        case 'inspect':
          const params = {
            professionStr,
            bqItemId: planItem.bqestidatadetailid,
            inspection: value || false
          }
          this.loading = true
          CombinationService.putInspect(params).then(res => {
            if (+res.code === 200) {
              this.getList()
            } else {
              this.$message.error('操作失败')
              this.loading = false
            }
          }).catch((e) => {
            console.log(e)
            this.loading = false
          })
          break
        // 设置/取消最佳组价
        case 'setBestCombination':
          if (item && planItem) {
            // 单条 方案 设置/取消最佳组价
            if (this.pageType === 'databaseBasis' && +planItem.inspected === 2) {
              // 电子档案室 审核通过的组价数据 才能 设为最佳组价/取消最佳组价
              return
            }
            const params = Object.assign({
              bestEsti: !!value, // 设置/取消设置
              bqitemIds: planItem.bqestidatadetailid // 方案Id
            }, parameter)
            if (!value) {
              this.$confirm({
                message: '确定取消设置最佳组价？',
                tips: '取消后，在P5端应用时，不再优先推送',
                dealData: params,
                submit: data => {
                  this.setBestEsti(data, value)
                },
                submitText: '确定'
              })
            } else {
              const hasSetEstis = [] // 之前已设置的最佳组价
              item.estiDetailList.map(planItemTemp => {
                if (planItemTemp.bestEsti && planItemTemp.bqestidatadetailid !== planItem.bqestidatadetailid) {
                  hasSetEstis.push(planItemTemp.bqestidatadetailid)
                }
              })
              params.hasSetEstis = hasSetEstis.join(',')
              this.setBestEsti(params, value)
            }
          } else {
            // 批量设置/取消 最佳组价
            if (bqitemid.length === 0) {
              errorText = value ? '请选择需要设为最佳组价的组价列表' : '请选择需要取消最佳组价的组价列表'
            }
            if (errorText) {
              this.$message.info(errorText)
              return
            }
            if (parameter.selectAllPages) {
              // 全选所有页时 查询已被设置的最佳组价列表
              const servieName = value ? 'getBestEstiIds' : 'getNoBestEstiIds'
              this.loading = true
              CombinationService[servieName](parameter).then(res => {
                if (+res.code === 200) {
                  console.log('getNoBestEstiIds ==== >', res)
                  if (res.data === '') {
                    if (value) {
                      this.$confirm({
                        message: '一条清单下只允许设置一个最佳组价方案',
                        noCancelBtn: true,
                        width: 450
                      })
                    } else {
                      this.$confirm({
                        message: '无可需要取消最佳组价的组价列表',
                        noCancelBtn: true,
                        width: 450
                      })
                    }
                  } else {
                    let ids
                    if (value) {
                      ids = res.data.map(resitem => resitem.bqestidatadetailid)
                    } else {
                      ids = JSON.parse(res.data)
                    }
                    this.setBestEsti(Object.assign(parameter, {
                      bestEsti: !!value,
                      bqitemIds: ids.join(',')
                    }), value)

                  }
                } else {
                  this.topButtonClick('refresh')
                }
              }).catch((e) => {
                console.log(e)
                this.loading = false
              })
            } else {
              // 并非全选所有页时
              this.setBestEsti(Object.assign(parameter, {
                bestEsti: !!value,
                bqitemIds: bqitemid.join(',')
              }), value)
            }
          }
          break
        // 删除方案
        case 'deletePlan':
          this.$confirm({
            message: '确定删除？',
            type: 'warning',
            tips: '删除后，数据将不可恢复',
            width: 370,
            dealData: parameter,
            submit: data => {
              this.deleteConfirm(data)
            },
            submitText: '确定删除'
          })
          break
        // 修改定额
        case 'editQuota':
          this.editQuota = {
            show: true,
            editData: {
              professionStr,
              bqSpecId: planItem.bqestidatadetailid,
              normGuid: quotaItem.normGUID,
              description: quotaItem.description
            }
          }
          break
        // 修改人材机数据
        case 'editMaterial':
          this.editMaterial = {
            show: true,
            editData: {
              professionStr,
              bqspecid: planItem.bqestidatadetailid,
              resId: materialItem.resID_GUID,
              description: materialItem.description,
              spec: materialItem.spec,
              unit: materialItem.unit
            }
          }
          break
        default:
      }
    },
    // 4.1 复制到电子档案室
    copyMaterialList (params) {
      let taskComplete = false
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.resetSelectAll++
                this.selectAllChange('', false)
                this.upload.title = '复制结果'
                this.upload.detailShow = true
                this.upload.show = true
                this.upload.text = `复制总条数 ${result.data
                  .CopyCompanyDataErr +
                result.data.CopyCompanyDataOK}， 复制成功 ${result.data.CopyCompanyDataOK}  条，复制失败  ${result.data.CopyCompanyDataErr} 条`
                this.upload.detail = []
                if (result.data.CopyCompanyDataErr > 0) {
                  this.upload.detail = result.data.ErrDetail
                }
              }, 1800)
            })
            this.topButtonClick('refresh')
          }
        }
      }
      CombinationService.estiCopy(params).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('copy', 1, params.modelType).then(({hit}) => {
        taskComplete = true
        afterTask()
      })
    },
    // 4.2 导出数据
    exportData (params) {
      let taskComplete = false
      const cacheKey = new Date().getTime()
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            console.log('exportData ==== >', result)
            // 操作记录
            let token = getCookie('ZJYTOKEN')
            let name = result.data
            if (result && (!result.data || result.data === 'null')) {
              !this.operationBatch && (this.$message.error('导出失败！'))
              return false
            }
            if (isIE()) {
              name = encodeURIComponent(name)
            } else {
              name = decodeURIComponent(name)
            }
            setTimeout(() => {
              window.location.href = `${backendUrl}/data_manage/esti/dowload?fileName=${name}&token=${token}`
            }, 1000)
            this.addOperationRecords(2, params.bqspecidLen)
          }
        }
      }
      CombinationService.exportData(Object.assign(params, {cacheKey})).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('export', 0, cacheKey).then(() => {
        taskComplete = true
        afterTask()
      })
    },
    // 4.3 修改 清单 确定
    editInventorySubmit (data) {
      let {description, spec, unit} = this.editInventory.editData
      if (data.description === description && data.spec === spec && data.unit === unit) {
        this.editInventory.show = false
        return
      }
      this.editInventory.show = false
      CombinationService.putBqItemData(data)
        .then(res => {
          if (+res.code === 200) {
            this.$message.success('修改成功')
            this.getList()
            this.addOperationRecords(3, 1)
          } else {
            // +data.code === 290004 无权限操作数据时 操作失败
            this.$message.error('操作失败')
          }
        }).catch(err => {
          console.log(err)
          this.$message.error('修改失败')
        })
    },
    // 4.3.1 修改 清单 取消
    editInventoryCancel () {
      this.editInventory.show = false
    },
    // 4.4 删除方案、清单 确定
    deleteConfirm (parameter) {
      // 删除个数
      let num = parameter.bqitemidLen
      if (parameter.selectAllPages) {
        num = this.totalCount - unselectedSpecIds.length
      }
      CombinationService.delEsti(parameter).then(res => {
        if (+res.code === 200) {
          // 操作记录
          this.addOperationRecords(1, num)
          if (!this.operationBatch) {
            this.$message.success('删除成功')
          }
          this.topButtonClick('refresh')
        } else {
          // +data.code === 290004 无权限操作数据时 操作失败
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('删除失败')
          }
        }
      })
    },
    // 4.5  移动到、批量移动到 确定
    moveToSubmit (params) {
      console.log(params)
      this.dialog.moveTo.show = false
      let taskComplete = 0
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
            !this.operationBatch && (this.$message.success('移动成功'))
            // 操作记录
            this.addOperationRecords(4, params.bqspecidLen)
          } else {
            !this.operationBatch && (this.$message.error(result.message || '移动失败'))
          }
          this.topButtonClick('refresh')
        }
      }
      CombinationService.moveEstiData(params).then(res => {
        console.log('moveNormData===', res)
        if (+res.code === 290004) {
          //  无权限操作数据 操作失败时
          if (window.moveProgressTimerEmitter){ clearTimeout(window.moveProgressTimerEmitter) }
          if (window.moveProgressTimer) {
            clearTimeout(window.moveProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true}) // 关闭进度条弹窗
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        } else {
          result = res
          afterTask()
        }
      })
      this.getProgress('move', 0, params.modelType).then(({hit}) => {
        taskComplete = hit
        afterTask()
      })
    },
    moveToCancel () {
      this.dialog.moveTo.show = false
    },
    // 4.6 设置/取消最佳组价
    setBestEsti (params, value) {
      const setServieName = value ? 'setBestEsti' : 'cancelBestEsti'
      // const {bqitemIds, bestEsti, hasSetEstis = []} = params
      if (value && this.operationBatch) {
        // 批量设置 最佳组价时 将需要取消的最佳组价的方案id寻找出来
        const hasSetEstis = []
        let dataList = this.dataList
        dataList.map(item => {
          let estiDetailList = item.estiDetailList.filter(
            chilidItem => chilidItem.checked
          )
          if (estiDetailList.length > 0) {
            estiDetailList = item.estiDetailList.filter(
              chilidItem => chilidItem.bestEsti && !chilidItem.checked
            )
            estiDetailList.map(chilidItem => {
              hasSetEstis.push(chilidItem.bqestidatadetailid)
            })
          }
        })
        params.hasSetEstis = hasSetEstis.join(',')
      }
      this.loading = true
      CombinationService[setServieName](params).then(res => {
        let message = ''
        if (+res.code === 200) {
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.success('设置成功')
            this.getList()
          }
        } else if (+res.code === 240011) {
          message = '节点已满'
        } else {
          // +data.code === 290004 无权限操作数据时 操作失败
          message = '操作失败'
        }
        if (message) {
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error(message)
          }
        }
      }).finally(() => { this.loading = false })
    },
    // 4.7 修改 定额数据 确定
    editQuotaSubmit (data) {
      if (data.description === this.editQuota.editData.description) {
        // 定额数据未变化 直接关闭弹窗
        this.editQuota.show = false
        return
      }
      this.editQuota.show = false
      CombinationService.putNormitemData(data).then(res => {
        if (+res.code === 200) {
          this.$message.success('修改成功')
          this.getList()
          // 操作记录
          this.addOperationRecords(3, 1)
        } else {
          // +data.code === 290004 无权限操作数据时 操作失败
          this.$message.error('修改失败')
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('修改失败')
      })
    },
    // 4.7.1 修改 定额数据 取消
    editQuotaCancel () {
      this.editQuota.show = false
    },
    // 4.8 修改 人材机数据 确定
    editMaterialSubmit (data) {
      let {editData} = this.editMaterial
      if (data.description === editData.description && data.spec === editData.spec && data.unit === editData.unit) {
        // 啥也没有修改 点击确定 直接关闭弹窗
        this.editMaterial.show = false
        return
      }
      this.editMaterial.show = false
      CombinationService.putResource(data)
        .then(res => {
          if (+res.code === 200) {
            this.$message.success('修改成功')
            this.getList()
            this.addOperationRecords(3, 1)
          } else {
            // +data.code === 290004 无权限操作数据时 操作失败
            this.$message.error('修改失败')
          }
        }).catch(err => {
          console.log(err)
          this.$message.error('修改失败')
        })
    },
    // 4.8 修改 人材机数据 确定
    editMaterialCancel () {
      this.editMaterial.show = false
    },
    selectAllChange (type, value) {
      uncheckedbqitemids = []
      unbqbaseinfoids = []
      unselectedSpecIds = []
      if (this.selectAll === type) {
        this.selectAll = ''
      } else {
        this.selectAll = type
      }
      let list = JSON.parse(JSON.stringify(this.dataList))
      list.forEach(item => {
        item.estiDetailList.forEach(citem => {
          citem.checked = value
        })
        item.checked = value
      })
      this.dataList = list
    },
    // 分页
    changePageCurrent (data) {
      this.parameter.pageNum = data
      this.getList()
    },
    changePageSize (data) {
      this.parameter.pageNum = 1
      this.parameter.pageSize = data
      this.getList()
    },
    // 获取列表
    getList (type) {
      this.loading = true
      // this.dataList = [];
      let parameter = this.parameter
      this.totalCount = 0
      CombinationService.getEstiItems(parameter).then(res => {
        if (+res.code === 200 && res.data) {
          if (type === 'refresh') {
            this.resetSelectAll++
            this.refreshRegionList++
          }
          let bqEstiDataDetailIds = {}
          const dataList = res.data.items || []
          dataList.forEach(ritem => {
            // unselectedSpecIds
            if (
              this.selectAll === 'all' &&
                unselectedSpecIds.indexOf(ritem.bqspecid) === -1
            ) {
              ritem.checked = true
            } else {
              ritem.checked = false
            }
            ritem.estiDetailList.forEach(citem => {
              if (
                this.selectAll === 'all' &&
                  uncheckedbqitemids.indexOf(citem.bqestidatadetailid) === -1
              ) {
                citem.checked = true
              } else {
                citem.checked = false
              }
              if (!bqEstiDataDetailIds[citem.bqestidatadetailid]) {
                bqEstiDataDetailIds[citem.bqestidatadetailid] = []
              }
              citem.normItem.map(ccitem => {
                bqEstiDataDetailIds[citem.bqestidatadetailid].push(
                  ccitem.normGUID
                )
              })
            })
          })
          bqEstiDataDetailIds = JSON.stringify(bqEstiDataDetailIds)
          CombinationService.getNormsData({
            bqEstiDataDetailIdJson: bqEstiDataDetailIds,
            regions: this.parameter.regionStr
          }).then(resdata => {
            console.log('getEstiItems====', res)
            if (+resdata.code === 200) {
              dataList.forEach(item => {
                item.childShow = true
                item.estiDetailList.forEach(planItem => {
                  planItem.childShow = true
                  planItem.normItem.forEach(quotaItem => {
                    if (resdata.data[quotaItem.normGUID]) {
                      quotaItem.resList =
                          resdata.data[quotaItem.normGUID].resList
                    }
                  })
                })
              })
              this.dataList = this.verifyPermission(dataList)
              console.log('dataList===', this.dataList[0])
            }
          }).finally(() => {
            this.loading = false
            this.$nextTick(() => {
              // 若用户点击了 展开到某个层级 则获取完数据后直接展开到当前层级
              if (this.combinationUnfoldLevel) {
                this.unfoldTo(this.combinationUnfoldLevel)
              }
            })
          })
          this.totalCount = res.data.total
        }
      }).catch((e) => {
        console.log(e)
        this.loading = false
      })
    },
    // 获取清单库
    getDbidsData () {
      let parameter = {
        regions: this.parameter.regionStr,
        bqCatalogIdGuids: this.parameter.professionStr
      }
      CombinationService.getDbidsData(parameter).then(res => {
        if (+res.code === 200 && res.data) {
          // console.log(res);
          this.inventoryList = res.data.dbids || []
          this.quotaList = res.data.series || []
        } else {
          this.inventoryList = []
          this.quotaList = []
        }
        this.inventoryQuotaListChanged++
      })
    },
    // 排序
    changeSort (type) {
      switch (type) {
        case 'time':
          this.parameter.inspectedSort = ''
          this.parameter.timeSort = +this.parameter.timeSort === 0 ? 1 : 0
          break
        case 'inspected':
          this.parameter.timeSort = ''
          this.parameter.inspectedSort = +this.parameter.inspectedSort === 0 ? 1 : 0
          break
        default:
      }
      this.parameter.pageNum = 1
      this.getList()
    },
    // 复选框点击
    checkboxTap (item, index) {
      setTimeout(() => {
        let datalist = JSON.parse(JSON.stringify(this.dataList))
        datalist[index].estiDetailList.forEach(dataitem => {
          dataitem.checked = datalist[index].checked
          if (this.selectAll === 'all') {
            if (!dataitem.checked) {
              if (uncheckedbqitemids.indexOf(dataitem.bqestidatadetailid) === -1) {
                uncheckedbqitemids.push(dataitem.bqestidatadetailid)
              }
              if (unbqbaseinfoids.indexOf(datalist[index].bqbaseinfoid) === -1) {
                unbqbaseinfoids.push(datalist[index].bqbaseinfoid)
              }
              if (unselectedSpecIds.indexOf(datalist[index].bqspecid) === -1) {
                unselectedSpecIds.push(datalist[index].bqspecid)
              }
            } else {
              if (uncheckedbqitemids.indexOf(dataitem.bqestidatadetailid) > -1) {
                uncheckedbqitemids.splice(uncheckedbqitemids.indexOf(dataitem.bqestidatadetailid), 1)
              }
              if (unbqbaseinfoids.indexOf(datalist[index].bqbaseinfoid) > -1) {
                unbqbaseinfoids.splice(unbqbaseinfoids.indexOf(datalist[index].bqbaseinfoid), 1)
              }
              if (unselectedSpecIds.indexOf(datalist[index].bqspecid) > -1) {
                unselectedSpecIds.splice(unselectedSpecIds.indexOf(datalist[index].bqspecid), 1)
              }
            }
          }
        })
        this.dataList = datalist
      }, 10)
    },
    // 复选框点击
    childCheckboxTap (item, pindex, index) {
      setTimeout(() => {
        let datalist = JSON.parse(JSON.stringify(this.dataList))
        if (this.selectAll === 'all') {
          if (!datalist[pindex].estiDetailList[index].checked) {
            if (uncheckedbqitemids.indexOf(datalist[pindex].estiDetailList[index].bqestidatadetailid) === -1) {
              uncheckedbqitemids.push(datalist[pindex].estiDetailList[index].bqestidatadetailid)
            }
            if (unbqbaseinfoids.indexOf(datalist[pindex].bqbaseinfoid) === -1) {
              unbqbaseinfoids.push(datalist[pindex].bqbaseinfoid)
            }
          } else {
            if (
              uncheckedbqitemids.indexOf(datalist[pindex].estiDetailList[index].bqestidatadetailid) > -1) {
              uncheckedbqitemids.splice(uncheckedbqitemids.indexOf(datalist[pindex].estiDetailList[index].bqestidatadetailid), 1)
            }
            if (unbqbaseinfoids.indexOf(datalist[pindex].bqbaseinfoid) > -1) {
              unbqbaseinfoids.splice(unbqbaseinfoids.indexOf(datalist[pindex].bqbaseinfoid), 1)
            }
          }
        }
        let checklistLen = datalist[pindex].estiDetailList.filter(
          dataitem => dataitem.checked
        ).length
        let childlistLen = datalist[pindex].estiDetailList.length
        if (checklistLen === childlistLen) {
          datalist[pindex].checked = true
        } else {
          datalist[pindex].checked = false
        }
        if (this.selectAll === 'all') {
          if (!datalist[pindex].checked) {
            if (unselectedSpecIds.indexOf(datalist[pindex].bqspecid) === -1) {
              unselectedSpecIds.push(datalist[pindex].bqspecid)
            }
          } else {
            if (unselectedSpecIds.indexOf(datalist[pindex].bqspecid) > -1) {
              unselectedSpecIds.splice(unselectedSpecIds.indexOf(datalist[pindex].bqspecid), 1)
            }
          }
        }
        this.dataList = datalist
      }, 10)
    },
    // 上传云文件
    UploadCloudFilesAffirm (vals, workspaceId) {
      let pathList = vals.map(item => item.path)
      let params = {
        IsOffline: false,
        ImportType: 2,
        SourceType: 2,
        userType: this.user.userType
      }
      let parameter = {
        params,
        pathList: JSON.stringify(pathList),
        uploadType: 7,
        workspaceId,
        spaceType: this.pageType === 'databaseBasis' ? 2 : 1
      }
      // this.uploadCloudFileParams = parameter
      Bus.$emit('beforeUploadCloudFile', vals, parameter)
      // CombinationService.uploadCloudFile(parameter).then(res => {
      //   if (+res.code === 200) {
      //     console.log("CombinationService ==== >", res);
      //   }
      // });
      // this.UploadCloudFilesShow = false;
    },
    UploadCloudFilesCancle () {
      this.UploadCloudFilesShow = false
    },
    // 标签
    labelDataSubmit (id, data) {
      console.log('labelDataSubmit', id)
      console.log('labelDataSubmit', data)
      // if (data.length === 0) {

      //   return;
      // }
      try {
        if (
          this.labelData.data.tagLabels === data.join('、') ||
            (this.labelData.data.tagLabels === null && data.join('、') === '')
        ) {
          this.labelData.show = false
          return
        }
      } catch (error) {
      }

      let parameter = {
        bqEstidataDetailId: id,
        estidataLabels: data.join(','),
        description: data.description
      }

      CombinationService.editLables(parameter).then(res => {
        if (+res.code === 200) {
          this.labelData.show = false
          this.getList()
        } else {
          this.saveError = res.message
          this.saveErrorIndex++
        }
      })
    },
    tagTap (item) {
      this.labelData.show = true
      this.labelData.data.id = item.bqestidatadetailid
      this.labelData.data.tagLabels = item.tagLabels
    },
    showDetail () {
      var win = window.open()
      // 流使用结束后 必须要关闭
      let htmlStr = ''
      this.upload.detail.map(item => {
        if (this.upload.title === '复制结果') {
          htmlStr += `<tr>
            <td>${item.c_sEstiBQCode}</td>
            <td>${item.EstiBQName}</td>
            <td>${item.CopyCompanyDataRepeat === true ? '重复' : ''}</td>
          </tr>`
          item.EstiInfo.map(citem => {
            htmlStr += `<tr>
              <td>${citem.EstiCode}</td>
              <td>${citem.EstiName}</td>
              <td></td>
            </tr>`
          })
        } else {
          htmlStr += `<tr>
            <td>${item.code}</td>
            <td>${item.name}</td>
            <td>${item.result}</td>
          </tr>`
        }
      })
      win.document.write(`<head>
        <title>${this.upload.title === '复制结果' ? '复制' : '导入'}详情</title>
        <meta http-equiv="Content-Type" content="text/html;charset=utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <style>
          *{margin:0;padding: 0;}
            .info{
              width: 1000px;
              margin: 20px auto;
            }
            table{
              border: 1px solid #ccc;
              border-collapse: collapse;
              border-spacing: 0;
              font-size: 14px;
            }
            caption{
              padding:8px 5px;
              border: 1px solid #ccc;
              border-bottom: none;
              text-align: left;
              font-size: 20px;
            }
            caption a{
              color: #2079FA;
              text-decoration: none;
              float: right;
            }
            tr{
              height: 30px;
            }
            tr:hover td{
              background-color: #E6F9FF;
            }
            th,
            td{
              padding:8px 5px;
              border: 1px solid #ccc;
              text-align: left;
            }
            th{
              background-color: #EEE;
              color: #666;
            }
          </style>
        </head>
        <body>
        <div class="info" id="___info">
          <table width="100%" cellspacing="0" cellpadding="0">
            <caption>${
  this.upload.title === '复制结果' ? '复制' : '定额导入'
}详情<a href="javascript:window.print()">打印</a></caption>
            <thead>
              <tr>
                <th width="200">编码</th>
                <th>名称</th>
                <th>未导入原因</th>
              </tr>
            </thead>
            <tbody>
            ${htmlStr}
            </tbody>
          </table>
        </div>
        <body></head>`)
      win.document.close()
    }
  }
}
</script>
<style lang="less">
  @import "./index";

  .right-content .combination-main {
    .tabcnt-simple {
      .table-wrapper .table-head-wrapper {
        margin-right: 0px;
      }

      .table-wrapper .table-body-wrapper {
        overflow-y: hidden;

        tr {
          height: 46px;

          &.h-34 {
            height: 34px;
          }

          &.h-32 {
            height: 32px;
          }

          &.h-34,
          &.h-32 {
            td {
              border-top: none !important;
            }
          }

          td {
            word-break: break-all;
          }
        }
      }
    }

    .content--options {
      padding-right: 0 !important;
    }

    .th-normal {
      height: 40px;
    }

    .empty-box {
      text-align: center;
      width: 100%;
      font-size: 26px;
      color: #999;
    }
  }

  @media (max-width: 1420px) {
    .right-content .combination-main {
      .table-name {
        width: 50px !important;
      }
    }
  }
</style>


<style lang="less" scoped>
  .view-more {
    display: inline-block;
    margin-top: 3px;
    width: 12px;
    height: 12px;
    background: transparent url("~@/assets/images/tree.png") 0 0 no-repeat;
  }

  .close {
    background-position: 0 -54px;
  }

  .tax {
    display: inline-block;
    margin-right: 5px;
    width: 16px;
    height: 16px;
    background: transparent url("~@/assets/images/tax.png") 0 0 no-repeat;
  }

  .inspected-click {
    color: #ff561a !important;
    cursor: pointer;
  }

  .trItem td {
    text-align: center;
  }

  .trItem .checkbox-td {
    text-align: left;
  }

  .trItem .td-btnbox {
    text-align: right;

    .font-green {
      color: #00C461 !important;
    }
  }

  .checkbox-label {
    /*margin-left: 6px;*/

    &.th {
      margin-left: 3px;
      position: absolute;
      left: 3px;
      top: 50%;
      margin-top: -11px;
      z-index: 10;
    }
  }

  .table-light {
    margin-top: 10px;

    thead {
      th {
        height: 34px;
        padding: 0 5px;
        background-color: #f1f7e3;
        color: #666;
        font-size: 12px;
      }
    }

    tbody {
      td {
        /*padding: 10px 5px !important;*/
        color: #333;
        font-size: 12px;
        border-bottom: none !important;
      }
    }
  }

  .more-hidden td {
    background: #fff !important;
  }

  .font-green {
    color: #00C461 !important;
  }

  .colspan {
    padding: 0px !important;
  }

  /*.checkbox-d {*/
  /*padding-left: 6px;*/
  /*}*/
  .marright0 {
    margin-right: 0px;
  }

  .groupTag {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 31px;
    padding: 3px 4px 4px;
    cursor: pointer;
    border: 1px solid #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .groupTag:hover {
    border: 1px solid #9ad7ff;
    background: #f0f8fe;
  }

  .zan {
    color: #ffa318;
    margin-left: 10px;
  }

  .shen-ok {
    border-radius: 2px;
    padding: 0 3px 2px 3px;
    font-size: 12px;
    background-color: #ff561a;
    color: #fff !important;
  }

  .w-icon-quxiaozuijiazujia {
    margin-right: 10px;
    cursor: pointer;
  }

  .iconfont {
    font-size: 16px;
  }

  .mar10 {
    margin-right: 10px;
  }

  .highlight td {
    background-color: #e7f3fb;
  }

  .page-box {
    position: fixed;
    bottom: 10px;
    /*width: calc(100% - 220px);*/
    /*width: calc(100% - 260px);*/
    /*min-width: 1100px;*/
    right: 10px;
  }
</style>
